"use strict";
/*
 * Created on 9. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ReleaseEditInfo_1 = require("../model/ReleaseEditInfo");

var ReleaseEditInfoConverter_1 = require("./ReleaseEditInfoConverter");
/**
 * Default implementation of {@link ApprovalStatusConverter}
 *
 * @author Radek Beran
 */


var ReleaseEditInfoConverterImpl =
/*#__PURE__*/
function (_ReleaseEditInfoConve) {
  _inherits(ReleaseEditInfoConverterImpl, _ReleaseEditInfoConve);

  function ReleaseEditInfoConverterImpl() {
    _classCallCheck(this, ReleaseEditInfoConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReleaseEditInfoConverterImpl).call(this));
  }
  /**
   * @inheritDoc
   */


  _createClass(ReleaseEditInfoConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ReleaseEditInfo_1.ReleaseEditInfo(source.settingsEditable);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, {
        settingsEditable: source.settingsEditable
      });
      return document;
    }
  }]);

  return ReleaseEditInfoConverterImpl;
}(ReleaseEditInfoConverter_1.ReleaseEditInfoConverter);

exports.ReleaseEditInfoConverterImpl = ReleaseEditInfoConverterImpl;